// Ob der Tab zu sehen ist, meldet der Client dem Server (task-015, docs/architektur-paket-2.md,
// „Protokoll v2“, ADR 0029, ADR 0030). Versteckt heißt beim Server sofort abwesend: Avatar weg,
// Hof-Uhr steht, Kuh im Unterstand. Beim Zurückkommen meldet der Client `visibility { hidden: false }`.
// Das holt allein niemanden zurück, entsperrt aber das Zurückholen: Solange der Server den Tab für
// versteckt hält, holt ihn keine Eingabe zurück. Erst die nächste Eingabe danach, die ohnehin als
// `move` oder `interact` hinausgeht, macht wieder anwesend.
//
// Gemeldet wird nur, was der Server noch nicht weiß. Nach jeder Begrüßung (auch nach einer
// Wiederverbindung) hält er einen für anwesend und sichtbar; liegt der Tab dann im Hintergrund,
// muss das neu hinaus.
//
// Reine Logik ohne DOM; `document.hidden` und `visibilitychange` hängt main.ts ein.
import { PROTOCOL_VERSION, type VisibilityMessage } from '@bauernhof/shared';

export interface Sichtbarkeitsmelder {
  /** Eine Begrüßung kam an: Der Server hält den Tab jetzt für sichtbar. */
  nachBegruessung(): void;
  /** Die Meldung, die zum Tab gerade fällig ist, oder null, wenn der Server es schon weiß. */
  faellig(hidden: boolean): VisibilityMessage | null;
  /** Die Meldung ist hinausgegangen. */
  gesendet(msg: VisibilityMessage): void;
}

export function createSichtbarkeitsmelder(): Sichtbarkeitsmelder {
  /** Was der Server über den Tab weiß; vor der ersten Begrüßung nichts. */
  let gemeldet: boolean | null = null;

  return {
    nachBegruessung() {
      gemeldet = false;
    },
    faellig(hidden) {
      if (gemeldet === null || gemeldet === hidden) return null;
      return { v: PROTOCOL_VERSION, t: 'visibility', hidden };
    },
    gesendet(msg) {
      gemeldet = msg.hidden;
    },
  };
}
